import React from 'react';
import propTypes from 'prop-types';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { PieCharts } from './PieCharts';
import { ComplianceSummaryTable } from './ComplianceSummaryTable';

export const ComplianceSummary = ({ data, tableData }) => (
  <>
    <MuiTitle isSize="4" hasTextColor="info" tag="h2">
      Compliance Summary
    </MuiTitle>
    <Columns>
      <Column>
        <PieCharts data={data} />
      </Column>
      <Column>
        <ComplianceSummaryTable loading={data == null} data={tableData} />
      </Column>
    </Columns>
  </>
);

ComplianceSummary.propTypes = {
  data: propTypes.object,
  tableData: propTypes.array.isRequired,
};

ComplianceSummary.defaultProps = {
  data: null,
};
